import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { GreyBackgroundButton, RedBackgroundButton } from '../../Global/GlobalButton';
import { USER_EXCHNAGE_URL } from '../../../Url/Url';
import { useNavigate } from 'react-router-dom';

export const UserSubmittedData = () => {
    const [eventsData, setEventsData] = useState([]);
    const navigate = useNavigate();
    const token = localStorage.getItem("token")
    useEffect(() => {
        const fetchEvents = async () => {
            try {
                const response = await axios.get(`${USER_EXCHNAGE_URL}/getUserEventEntries`,{
                    headers:{
                        Authorization: `Bearer ${token}`,

                    }
                });
                if (response.status === 200) {
                    const data = response.data.data
                    console.log(data,"data")
                    setEventsData(data);
                }
            } catch (error) {
                console.error("Error fetching events:", error);
            }
        };
        fetchEvents();
    }, []);
    const handlePaymentClick = (eventId) => {
        navigate('/user-pending-payment', { state: { eventId } });
    };


    return (
        <div className="p-6 bg-white rounded-lg shadow-md flex justify-center">
            <div className="w-3/4">
                <h2 className="text-xl font-bold mb-4 mt-4 text-center">User Submitted Events</h2>
                <table className="w-full border-collapse border border-gray-300 text-center">
                    <thead>
                        <tr className="bg-gray-100">
                            <th className="border ">Event Name</th>
                            <th className="border ">Event URL</th>
                            <th className="border ">Closing Date</th>
                            <th className="border ">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {eventsData.map(event => (
                            <tr key={event.eventId} className="text-center border">
                                <td className="border ">{event.event_name}</td>
                                <td className="border ">
                                    <a href={event.event_url} className="text-blue-500 underline" target="_blank" rel="noopener noreferrer">
                                        Visit Event
                                    </a>
                                </td>
                                <td className="border ">{new Date(event.closing_date).toLocaleDateString()}</td>
                                <td className="border ">
                                    {event.is_completed === 0 ? (
                                        <RedBackgroundButton className="bg-blue-500 text-white px-4 py-2 rounded" onClick={() => handlePaymentClick(event.eventId)}>Pay Now</RedBackgroundButton>
                                    ) : (
                                        <span className="text-green-600">Done</span>
                                    )}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <GreyBackgroundButton style={{marginTop:"2rem", marginLeft:"2rem", marginBottom:"1rem" }} onClick={()=> navigate("/user-dashboard")}>Back To Dashboard</GreyBackgroundButton>
        </div>
    );
};
